import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography, Button, Alert } from 'foundations-library/components'
import { getValue } from 'firebase-utils'
import { ScreenSizeContext } from 'providers'

const jss = () => ({
    campaignsLandingPage: {
    },
    imgContainer: {
        padding: '0 20px',
        marginBottom: 80,
        display: 'flex',
        justifyContent: 'center'
    },
    title: {
        marginBottom: 10
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    alert: {
        margin: '20px auto 50px auto',
        width: ({ isMobile }) => isMobile ? '100%' : '900px'

    }
})

const useStyles = makeStyles(jss)

interface PropsInterface {
    onClickAddNew(): unknown
}

/**
 *
 */
const LandingPage = ({ onClickAddNew }: PropsInterface): JSX.Element => {
    const { mobile } = useContext(ScreenSizeContext)
    const styles = useStyles({ isMobile: mobile })
    return <div className={styles.campaignsLandingPage} data-testid='campaigns-landing-page'>
        <div className={styles.imgContainer} data-testid='campaigns-landing-page-container'>
            <img src="https://s3.us-west-2.amazonaws.com/assets.phone.com/sms-registration/campaings-landing-page.png" alt="campaings-landing-page" data-testid='campaigns-landing-page-img' />
        </div>
        <Typography variant='h4' className={styles.title} align='center' data-testid='campaigns-landing-page-title'>
            Start Campaign Registration
        </Typography>
        <Typography align='center' data-testid='campaigns-landing-page-subtitle'>
            Create and submit a campaign to enable compliant SMS messaging under an approved brand.
        </Typography>
        <Alert className={styles.alert} withGradient level='success' icon='infotip-sm'>
            {getValue('sms_enrollment_campaigns_empty_page_alert')}
        </Alert>
        <div className={styles.buttonContainer} data-testid='campaigns-landing-page-buttons'>
            <Button icon='add' iconLeft onClick={onClickAddNew} data-testid='campaigns-landing-page-add-button'>
                {getValue('sms_enrollment_add_new_campaign')}
            </Button>
        </div>
    </div>
}

export default LandingPage
